import React from 'react'
import { Card, Tooltip } from 'antd'
// import { StopOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { DateFormat, DateUtility } from 'utility'
import {
  CommonColorButton,
  FlexRowBetween,
  ImageLoad,
  UserAvatarWithName,
} from 'components'
import { VideoStats } from './stats'
import { ReadMoreBox } from './read-more'
import { ArrowCounterClockwise, Eye, Trash } from 'phosphor-react'

export const ImageContainer = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;
  height: 180px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover .overlay {
    opacity: 1;
  }
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`

export const OverlayText = styled.span`
  color: white;
  font-size: 14px;
  // font-weight: bold;
  text-transform: capitalize;
  // border-bottom: 1px solid #fff;
  padding-bottom: 5px;
`

export const StyledCard = styled(Card)`
  padding: 12px;
  position: relative;
  height: 430px;
  background: #ffff;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  .ant-card-body {
    padding: 16px 0 0 0;
  }
  @media (min-width: 1300px) {
    height: 470px;
  }
`

export const VideoDetails = styled.div`
  margin-top: 10px;
  p {
    line-height: 22px;
    color: #808080;
    font-weight: normal;
  }
`

export const VideoCardWrapper = styled.div`
  position: relative;

  &:hover .overlay {
    opacity: 1;
  }
  .ant-card-cover img {
    border-radius: 12px;
    width: 100%;
    display: block;
  }
`

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
export const Title = styled.h5`
  font-size: 24px;
  font-weight: bold;
  color: #000f42;
  margin: 15px 10px 10px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 150px;
  @media (max-width: 1280px) {
    font-size: 16px;
    margin: 5px;
  }
`
export const CustomButton = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #ffe9e5;
  color: #e22400;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  gap: 5px;

  &:hover {
    background-color: #ffd4cc;
  }
  @media (max-width: 1280px) {
    padding: 8px 16px;
    font-size: 12px;
  }
`

export const StyledH6 = styled.h6`
  font-size: 14px;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 8px;
`

export const ItemWrapper = styled.div`
  flex-direction: column;
  display: flex;

  column-gap: 20px;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 500;
`

const VideoStatsContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 30px 10px 0;
`

export const DotSeparator = styled.span``

export const VideoCard = ({ onOpen, item, toggleBlock, openReviewModal }) => (
  <VideoCardWrapper>
    <StyledCard
      cover={
        <ImageContainer onClick={onOpen}>
          <ImageLoad src={item?.thumbnail_url} alt="example" />
          <Overlay className="overlay">
            <OverlayText>View Details</OverlayText>
          </Overlay>
        </ImageContainer>
      }
      actions={[]}
    >
      <TitleRow>
        <div>
          <Tooltip title={item?.title}>
            <Title ellipsis={{ tooltip: true }}>{item?.title}</Title>
          </Tooltip>
        </div>
        <div>
          {item?.isActive ? (
            <CommonColorButton
              onClick={() => toggleBlock(item._id, !item.isActive)}
              icon={<Trash size={20} />}
              tooltipTitle="Remove"
            />
          ) : (
            <CommonColorButton
              variant="blue"
              onClick={() => toggleBlock(item._id, !item.isActive)}
              icon={<ArrowCounterClockwise size={20} />}
              tooltipTitle="Restore"
            />
          )}

          {openReviewModal && (
            <CommonColorButton
              variant="green"
              onClick={openReviewModal}
              icon={<Eye size={20} />}
              tooltipTitle="Review"
            />
          )}
        </div>
      </TitleRow>
      <FlexRowBetween className="align-items-center">
        <UserAvatarWithName
          id={item.user?.fid}
          title={item?.user?.name}
          url={item?.user?.image}
        />
      </FlexRowBetween>
      <VideoDetails>
        <StyledH6>About this video</StyledH6>
        <ReadMoreBox text={item?.description} />
        <div className="d-flex">
          <ItemWrapper>
            <div>
              <span>
                {DateUtility.formatDate(
                  new Date(item?.createdAt),
                  DateFormat.fullDate,
                )}
              </span>
            </div>
            <div>
              <span>{item?.competition_name} </span>

              <span>
                {' '}
                <DotSeparator className="mr-2">•</DotSeparator>Round{' '}
                {item?.round_number}
              </span>
            </div>
          </ItemWrapper>
        </div>
      </VideoDetails>
      <VideoStatsContainer>
        <VideoStats item={item} />
      </VideoStatsContainer>
    </StyledCard>
  </VideoCardWrapper>
)
